import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { ddmmyyyy, num } from "../../lib/format";
import { ExportButton } from "../ExportButton";
import { useAuth } from "../../context/AuthContext";

export const FabricStock = () => {
  const { can } = useAuth();
  const [list, setList] = useState(null);
  const [all, setAll] = useState(false);
  useEffect(() => {
    api.get("/fabric-stock").then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  if (!list) return <p className="text-muted-foreground">Loading…</p>;
  const shown = (all ? list : list.filter((l) => l.available > 0)).slice().sort((a, b) => (a.fabricator_name ? 0 : 1) - (b.fabricator_name ? 0 : 1) || (a.fabricator_name || "").localeCompare(b.fabricator_name || ""));
  return (
    <div className="space-y-3" data-testid="fabric-stock">
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs text-muted-foreground">Fabric at each factory: GRN received, minus issued to jobs and returned to supplier, plus leftover returned.</p>
        <ExportButton name="fabric" className="shrink-0" />
      </div>
      <label className="flex min-h-[44px] items-center gap-3 text-sm font-medium">
        <input type="checkbox" className="h-5 w-5" checked={all} onChange={(e) => setAll(e.target.checked)} data-testid="fabric-stock-show-all" /> Show fully issued fabric too
      </label>
      {!shown.length && <p className="panel p-6 text-center text-muted-foreground" data-testid="fabric-stock-empty">No fabric in stock.</p>}
      {shown.map((l, n) => (
        <div key={l.key} className="space-y-2">
        {(n === 0 || shown[n - 1].fabricator_name !== l.fabricator_name) && <h3 className="mono-label px-1 pt-2 text-brand" data-testid={`fabric-factory-${l.fabricator_name || "none"}`}>{l.fabricator_name || "Not assigned to a factory"} · {num(shown.filter((x) => x.fabricator_name === l.fabricator_name).reduce((a, x) => a + x.available, 0))} available</h3>}
        <div className="panel space-y-1 p-4" data-testid={`fabric-stock-${l.grn_no}-${l.code || l.description}`}>
          <div className="flex justify-between gap-3">
            <p className="min-w-0 font-semibold">{l.description}{l.colour ? ` (${l.colour})` : ""} {l.code && <span className="mono text-xs text-muted-foreground">[{l.code}]</span>}</p>
            <p className="mono shrink-0 font-bold text-brand">{num(l.available)} {l.uom}</p>
          </div>
          <p className="text-xs text-muted-foreground">{l.vendor_name} · {l.po_no} · {l.grn_no} {ddmmyyyy(l.grn_date)} · at {l.location || "—"}</p>
          <p className="mono text-xs text-muted-foreground">Received {num(l.received)} · net out {num(l.issued)}</p>
        </div>
        </div>
      ))}
      {list.some((l) => l.available > 0) && can("jobs_write") && <Link to="/jobs/new" className="btn btn-primary w-full" data-testid="fabric-stock-issue-btn">Issue fabric to fabricator</Link>}
    </div>
  );
};
